export const includesSaltus = (name: string | undefined | null) =>
  (name?.toLocaleLowerCase() || '').includes('saltus');
